export default __webpack_public_path__ + "static/BackgroundMobile2024-8e025047b90a48aa48cc4fb149398170.jpg";